import { Badge, Col, Form, Select } from "antd";

/* ============================================================
   ช่องค้นหา "สถานะการใช้งาน" ของหน้า Access ใน ERP Master
   ค่าเริ่มต้นแสดงเฉพาะที่เปิดใช้งาน — ที่ปิดแล้วต้องเลือกเองถึงจะเห็น
============================================================ */

export const ACTIVE_STATUS_DEFAULT = "เปิดการใช้งาน";

export const ACTIVE_STATUS_OPTIONS = [
  { value: "เปิดการใช้งาน", label: <Badge status="success" text="เปิดการใช้งาน" /> },
  { value: "ปิดการใช้งาน", label: <Badge status="error" text="ปิดการใช้งาน" /> },
  { value: "ทั้งหมด", label: <Badge status="default" text="ทั้งหมด" /> },
];

/** ใส่ค่าเริ่มต้นให้ค่าที่กู้คืนมา ถ้ายังไม่เคยเลือกสถานะไว้ */
export const withDefaultStatus = (values) => {
  const v = { ...(values || {}) };
  if (!v.active_status) v.active_status = ACTIVE_STATUS_DEFAULT;
  return v;
};

/** ช่องเลือกสถานะ พร้อม Col ครอบ — ใช้ใน Row ของฟอร์มค้นหาได้เลย */
export default function ActiveStatusItem({ onChange, span }) {
  const col = span || { xs: 24, sm: 24, md: 12, lg: 12, xl: 8 };
  return (
    <Col {...col}>
      <Form.Item label="สถานะการใช้งาน" name="active_status">
        <Select
          style={{ width: "100%", height: 40 }}
          options={ACTIVE_STATUS_OPTIONS}
          placeholder="เลือกสถานะ"
          onChange={onChange}
        />
      </Form.Item>
    </Col>
  );
}
